import MobileCartWidget from '@/components/cart/MobileCartWidget.vue'
import LoginForm from '@/components/forms/LoginForm.vue'
import DescriptionModal from '@/components/modals/DescriptionModal.vue'
import MembershipModal from '@/components/modals/MembershipModal.vue'
import EventBus from '@/helpers/EventBus'
import { languageItem } from '@/helpers/LanguageHelpers'
import { ModalCloseHandlerFn, openModal } from '@/helpers/Modals'
import { Vue } from 'vue-property-decorator'
import TermsModal from '../checkout/components/TermsModal.vue'
import CartExpiryModal from '../components/modals/CartExpiryModal.vue'

/**
 * TODO Move these to their respective Vue components?
 * @see <ReloadModal>
 */

export function openLoginModal(): Promise<void> {
  return new Promise((resolve, reject) => {
    const t = languageItem('loginForm')
    const modals = Vue.prototype.$modals
    openModal({
      component: LoginForm,
      name: 'login',
      title: t.title,
      size: 'sm',
      props: {
        showBecomeMemberLink: true,
      },
    })

    // TODO Handle all dismiss/close events on the modal like this?
    // TODO
    EventBus.$on('tix:login:dismiss', () => {
      modals.close()
      reject()
    })

    EventBus.$on('tix:login:success', () => {
      modals.close()
      resolve()
    })
  })
}

export function registerModalEventListeners() {
  //dismisses a modal by name
  EventBus.$on('tix:modal:dismiss', (modalName) => {
    const modals = Vue.prototype.$modals
    modals.close({
      $index(data, modals) {
        return modals.findIndex((modal) => modal.name === modalName)
      },
    })
  })
}

export function openMembershipModal() {
  const t = languageItem('membershipModal')
  openModal({
    name: 'membership-modal',
    title: t.title,
    component: MembershipModal,
  })
}

export function openCartExpiryModal(title: string, onClose?: ModalCloseHandlerFn) {
  openModal({
    name: 'cart-expiry-modal',
    title,
    closeable: false,
    size: 'sm',
    component: CartExpiryModal,
    onClose,
  })
}

export function openTermsModal(title: string, onClose?: ModalCloseHandlerFn): Promise<void> {
  return new Promise(() =>
    openModal({
      name: 'terms-conditions',
      component: TermsModal,
      title,
      onClose,
    }),
  )
}

export function openDescriptionModal(content: string, title: string | undefined = '') {
  openModal({
    name: 'description-modal',
    component: DescriptionModal,
    title,
    mobile: 'full-screen',
    props: { content },
  })
}

export function openCartModal() {
  openModal({
    name: 'mobile-cart',
    component: MobileCartWidget,
    title: 'Your Cart',
  })
}

export function closeCartModal() {
  Vue.prototype.$modals.close({ name: 'mobile-cart' })
}
